const GET_BILLINGLDOCUMENTDETAIL_LIST = 'GET_BILLINGLDOCUMENTDETAIL_LIST';

export default {
  /** 請求書明細一覧 取得 */
  GET_BILLINGLDOCUMENTDETAIL_LIST,
};
